import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import ContactOrganizer from '@/components/ContactOrganizer/ContactOrganizer';
import TextDivider from '@/components/Divider/TextDivider';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import styles from '../styles/Home.module.css';

interface OnlineEventProps {
  infoText: string;
}

const OnlineEvent: React.FC<OnlineEventProps> = ({ infoText }) => {
  const SEARCH_EVENTS_URL = useEventbriteUrl('SEARCH_EVENTS_URL');
  const handleOnSearchEventsClick = () => {
    window.open(SEARCH_EVENTS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="online-event">
      <ContactOrganizer infoText={infoText} />
      <TextDivider text="or" />
      <Button
        variant="secondary"
        className={styles['no-border-button']}
        data-testid="search-event-button-element"
        onClick={handleOnSearchEventsClick}
      >
        Search events
      </Button>
    </div>
  );
};

export default OnlineEvent;
